/* Product description layout (ported from the Horizon WORK theme). Formatting only: every word stays. */
  // Lay out pasted descriptions consistently. Only the formatting changes: every word stays.
  (() => {
    const words = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim().split(" ").filter(Boolean);
    const clean = (s) => s.replace(/\s+/g, " ").trim();
    const bullet = /^\s*[•·▪●◦\-–—*]\s*/;
    const spec = /^([^:–—-]{1,40}?)\s*(?:\s[-–—]\s|:\s*)(.+)$/;
    // Readable on a light background? Drops pale pasted colours (gold, white, yellow); keeps reds, greens, etc.
    const isPale = (c) => {
      const m = c.match(/\d+(\.\d+)?/g);
      if (!m || m.length < 3) return false;
      const [r, g, b] = m.slice(0, 3).map(Number);
      return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255 > 0.6;
    };
    const makeSpecRow = (li) => {
      const m = clean(li.textContent).match(spec);
      if (!m) return;
      const label = document.createElement("span");
      label.className = "pdesc-specs__label";
      label.textContent = m[1].trim();
      const value = document.createElement("span");
      value.className = "pdesc-specs__value";
      value.textContent = m[2].trim();
      li.replaceChildren(label, value);
    };
    const organiseList = (list) => {
      const items = Array.prototype.filter.call(list.children, (li) => li.tagName === "LI");
      if (items.length < 2) return;
      const plain = items.filter((li) => !li.querySelector("ul, ol, img, a"));
      const matches = plain.filter((li) => spec.test(clean(li.textContent)));
      if (matches.length < Math.ceil(items.length * 0.6)) return;
      list.classList.add("pdesc-specs");
      matches.forEach(makeSpecRow);
    };

    // Remove a pasted "·" / "•" at the start of a line, even when it sits inside its own <span>.
    const stripLeadingBullet = (root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let t;
      while ((t = walker.nextNode())) {
        if (!t.textContent.trim()) continue;
        if (bullet.test(t.textContent)) {
          t.textContent = t.textContent.replace(bullet, "");
          let p = t.parentNode;
          if (!t.textContent.trim()) t.textContent = "";
          while (p && p !== root && !p.textContent.trim() && !p.querySelector("img, svg")) {
            const up = p.parentNode;
            p.remove();
            p = up;
          }
        }
        return;
      }
    };

    // "Key Features & Specifications" (or any "Specifications" heading): the whole section becomes a table.
    const specHeading = /key\s*features\s*(&|&amp;|and)\s*specifications?/i;
    const isHeadingNode = (n) => {
      if (/^H[1-4]$/.test(n.tagName)) return true;
      if (n.tagName !== "P") return false;
      const t = clean(n.textContent);
      if (!t || t.length > 60 || /[.!?,]$/.test(t)) return false;
      const rest = n.cloneNode(true);
      rest.querySelectorAll("strong, b").forEach((b) => b.remove());
      return !!n.querySelector("strong, b") && !rest.textContent.trim();
    };
    const rowParts = (text) => {
      const t = clean(text.replace(/\u00a0/g, " ")).replace(bullet, "");
      let m = t.match(/^([^:]{1,60}?)\s*:\s*(.+)$/);
      if (!m) m = t.match(/^(.{1,40}?)\s+[-–—]\s+(.+)$/);
      return m ? [m[1].trim(), m[2].trim()] : [t];
    };
    const buildSpecTables = (el) => {
      Array.prototype.slice.call(el.children).forEach((head) => {
        if (head.hidden || !isHeadingNode(head) || !specHeading.test(head.textContent)) return;
        const nodes = [];
        let n = head.nextElementSibling;
        while (n && !isHeadingNode(n) && /^(P|UL|OL|DIV)$/.test(n.tagName) && !n.querySelector("img, iframe, video, table")) {
          nodes.push(n);
          n = n.nextElementSibling;
        }
        const lines = [];
        nodes.forEach((node) => {
          if (/^(UL|OL)$/.test(node.tagName)) {
            node.querySelectorAll("li").forEach((li) => lines.push(li.textContent));
          } else {
            node.innerHTML.split(/<br\s*\/?>/i).forEach((h) => {
              const d = document.createElement("div");
              d.innerHTML = h;
              lines.push(d.textContent);
            });
          }
        });
        const rows = lines.map((l) => clean(l)).filter((l) => l && !/^[•·▪●◦\-–—*]+$/.test(l)).map(rowParts);
        if (rows.length < 2 || rows.filter((r) => r.length === 2).length < 1) return;
        const table = document.createElement("table");
        table.className = "pdesc-spec-table pdesc-key-specs";
        const tbody = document.createElement("tbody");
        rows.forEach((r) => {
          const tr = document.createElement("tr");
          r.forEach((txt) => {
            const td = document.createElement("td");
            td.textContent = txt;
            tr.appendChild(td);
          });
          if (r.length === 1) { tr.firstChild.colSpan = 2; tr.className = "pdesc-spec-note"; }
          tbody.appendChild(tr);
        });
        table.appendChild(tbody);
        nodes[0].replaceWith(table);
        nodes.slice(1).forEach((x) => x.remove());
      });
    };

    const run = () => document.querySelectorAll(".mps-pdesc:not([data-pdesc-done])").forEach((el) => {
      const titleWords = new Set(words(el.dataset.productTitle || ""));
      el.dataset.pdescDone = "";
      buildSpecTables(el);

      // 1. Hide the first line only when it repeats the product name.
      let first = el.firstElementChild;
      while (first && (first.tagName === "META" || (!first.textContent.trim() && !first.querySelector("img, iframe, video, table")))) {
        first = first.nextElementSibling;
      }
      if (first && /^(H[1-4]|P)$/.test(first.tagName) && titleWords.size) {
        const lineWords = words(first.textContent);
        const shared = lineWords.filter((w) => titleWords.has(w)).length;
        if (lineWords.length && lineWords.length <= titleWords.size + 3 && shared / lineWords.length >= 0.7) first.hidden = true;
      }

      // 2. Pale pasted text colours become the normal text colour.
      el.querySelectorAll("[style*='color']").forEach((n) => {
        if (n.style.color && isPale(n.style.color)) n.style.color = "";
      });

      // 3. "• line<br>• line" paragraphs become real lists (inner bold/links kept).
      el.querySelectorAll("p").forEach((p) => {
        if (!p.querySelector("br")) return;
        const lines = [[]];
        Array.prototype.forEach.call(p.childNodes, (n) => {
          if (n.nodeName === "BR") lines.push([]);
          else lines[lines.length - 1].push(n);
        });
        const filled = lines.filter((l) => clean(l.map((n) => n.textContent).join("")));
        if (filled.length < 2 || !filled.every((l) => bullet.test(l.map((n) => n.textContent).join("")))) return;
        const ul = document.createElement("ul");
        filled.forEach((l) => {
          const li = document.createElement("li");
          l.forEach((n) => li.appendChild(n));
          stripLeadingBullet(li);
          ul.appendChild(li);
        });
        p.replaceWith(ul);
      });

      // 3b. Real list items that also start with a typed dot: keep one bullet only.
      el.querySelectorAll("li").forEach(stripLeadingBullet);

      // 4. Short label lines become subheadings; long sentence "headings" read as an intro line.
      Array.prototype.forEach.call(el.children, (node) => {
        if (node.hidden) return;
        const t = clean(node.textContent);
        if (/^H[2-4]$/.test(node.tagName) && t.length > 90) { node.classList.add("pdesc-lead"); return; }
        if (node.tagName !== "P") return;
        if (!t) { if (!node.querySelector("img, iframe, video")) node.classList.add("pdesc-empty"); return; }
        if (t.length > 45 || /[.!?,]$/.test(t)) return;
        const next = node.nextElementSibling;
        const rest = node.cloneNode(true);
        rest.querySelectorAll("strong, b").forEach((b) => b.remove());
        const allBold = node.querySelector("strong, b") && !rest.textContent.trim();
        if (allBold || (next && /^(UL|OL|TABLE|DIV)$/.test(next.tagName))) node.classList.add("pdesc-subhead");
      });

      // 5. Other lists stay as normal bullet lists: only "Key Features & Specifications" becomes a table (see buildSpecTables).

      // 6. Two-column tables get the same spec look.
      el.querySelectorAll("table").forEach((table) => {
        const rows = table.querySelectorAll("tr");
        if (rows.length && Array.prototype.every.call(rows, (tr) => tr.children.length === 2)) table.classList.add("pdesc-spec-table");
      });
    });
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
    document.addEventListener("shopify:section:load", run);
  })();
